import { render, staticRenderFns } from "./Regioni.vue?vue&type=template&id=e7773cac&"
import script from "./Regioni.vue?vue&type=script&lang=ts&"
export * from "./Regioni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports